module.exports = __webpack_public_path__ + "media/mypage/images/jisseki/jisseki16_sp-25753ff88a5002571169055e127f02fc.jpg";